import { render, staticRenderFns } from "./BlackList.vue?vue&type=template&id=706c8064&"
import script from "./BlackList.vue?vue&type=script&lang=ts&"
export * from "./BlackList.vue?vue&type=script&lang=ts&"
import style0 from "./BlackList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports